import API_URL from "../utils/API_URL";

export default {
  refreshTokenEndpoint: API_URL + "/auth/refresh",
  loginEndpoint: API_URL + "/auth/login",
  logoutEndpoint: API_URL + "/auth/logout",
};
